import quatre95 from './quatre95.png';
import urbania from './urbania.png';
import universites from './universites.png';
import dehors from './dehors.png';

const downloadIcons = {
    quatre95,
    urbania,
    universites,
    dehors,
};

export default downloadIcons;
